<template>
    <div class="fill-height">
        <v-row class="fill-height" justify="center" align="center">
            <v-col cols="auto">
                <v-card class="pa-15 rounded-3xl" max-width="500px" color="surface" elevation="0">
                    <v-form ref="formReset">
                        <v-row>
                            <v-col cols="12">
                                <v-row align="center" justify="center">
                                    <v-col cols="auto">
                                        <v-img max-width="100px" contain src="/images/logo_roxo.png" />
                                    </v-col>
                                    <v-col cols="auto" class="text-center primary--text">
                                        <span class="text-h5">Nova Senha</span><br>
                                        <span class="text-body-2">Crie uma senha forte para sua conta</span>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col v-if="error_message" cols="12">
                                <v-alert type="error darken-4">
                                    {{ error_message }}
                                </v-alert>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="password"
                                    label="Nova Senha"
                                    :disabled="loading"
                                    :rules="password_rules"
                                    type="password"
                                    color="primary"
                                    @input="checkStrength"
                                />
                                <v-progress-linear
                                    v-if="password"
                                    :value="strength_score * 25"
                                    :color="strength_color"
                                    height="5"
                                    rounded
                                    class="mt-1"
                                ></v-progress-linear>
                                <div v-if="password" class="text-caption text-right mt-1" :class="`${strength_color}--text`">
                                    Força: {{ strength_text }}
                                </div>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="confirm_password"
                                    label="Confirmar Senha"
                                    :disabled="loading"
                                    :rules="confirm_password_rules"
                                    type="password"
                                    color="primary"
                                />
                            </v-col>
                            <v-col cols="12" class="d-flex justify-center">
                                <v-btn color="primary" dark :loading="loading" :disabled="loading" @click="resetPassword" class="rounded-xl" large block elevation="0">Redefinir Senha</v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>

        <v-snackbar v-model="snackbar_show" :color="snackbar_color" top right>
            {{ snackbar_text }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar_show = false">Fechar</v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import zxcvbn from "zxcvbn";

export default {
    data() {
        return {
            password: null,
            confirm_password: null,
            loading: false,
            error_message: null,
            strength_score: 0,
            password_rules: [
                v => !!v || "Digite uma senha",
                v => (v && v.length >= 8) || "A senha deve ter no mínimo 8 caracteres",
                v => (v && /[A-Z]/.test(v)) || "A senha deve conter pelo menos uma letra maiúscula",
                v => (v && /[a-z]/.test(v)) || "A senha deve conter pelo menos uma letra minúscula",
                v => (v && /[0-9]/.test(v)) || "A senha deve conter pelo menos um número",
                v => (v && /[!@#$%^&*+-]/.test(v)) || "A senha deve conter pelo menos um caractere especial (!@#$%^&*+-)"
            ],
            confirm_password_rules: [
                v => !!v || "Confirme sua senha",
                v => v === this.password || "As senhas não coincidem"
            ],
            snackbar_show: false,
            snackbar_text: "",
            snackbar_color: ""
        };
    },
    computed: {
        strength_color() {
            const colors = ["error", "orange", "warning", "info", "success"];
            return colors[this.strength_score];
        },
        strength_text() {
            const texts = ["Muito Fraca", "Fraca", "Média", "Forte", "Muito Forte"];
            return texts[this.strength_score];
        }
    },
    methods: {
        ...mapActions("auth", ["ActionResetPassword"]),
        checkStrength() {
            if (!this.password) {
                this.strength_score = 0;
                return;
            }
            const result = zxcvbn(this.password);
            this.strength_score = result.score;
        },
        async resetPassword() {
            if (this.$refs.formReset.validate()) {
                this.loading = true;
                this.error_message = null;
                
                const token = this.$route.query.token;
                const email = this.$route.query.email;

                if (!token || !email) {
                    this.error_message = "Link inválido ou expirado.";
                    this.loading = false;
                    return;
                }

                try {
                    await this.ActionResetPassword({
                        token,
                        email,
                        password: this.password,
                        password_confirmation: this.confirm_password
                    });

                    this.snackbar_text = "Senha redefinida com sucesso!";
                    this.snackbar_color = "success";
                    this.snackbar_show = true;

                    setTimeout(() => {
                        this.$router.push({ name: "auth" });
                    }, 2000);
                } catch (error) {
                    const msg = error?.response?.data?.error || "Erro ao redefinir senha";
                    this.error_message = msg;
                } finally {
                    this.loading = false;
                }
            }
        }
    }
};
</script>
